export default __webpack_public_path__ + "static/media/logo_open_white.7f1ae3ed.svg";